var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMigration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#003C71",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 55.5v-32"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M21.5 33.5l10-10 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M39.5 41.5h12c5.6-.5 10-5.3 10-11 0-5.8-4.4-10.5-10.1-11-1-10.1-9.5-18-19.9-18-9 0-16.6 6-19.1 14.2-6.2 1-10.9 6.3-10.9 12.8 0 6.8 5.3 12.5 12 13h10"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigration);
export default __webpack_public_path__ + "static/media/migration.a79b7f1d080d2eea6d22b33b3b8971ca.svg";
export { ForwardRef as ReactComponent };